var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mt-4"},[_c('div',{staticClass:"col-2 d-none d-lg-block"}),_c('div',{staticClass:"col-12 col-lg-9 ml-3 guide-list"},[_c('h4',{staticClass:"mt-0",attrs:{"id":"overview"}},[_vm._v("Miscellaneous")])])])}
var staticRenderFns = []

export { render, staticRenderFns }